import cookies from 'js-cookie';
import { REACT_APP_API_BASE_URL } from '../config/environment';
import { ACCESS_TOKEN_COOKIE_KEY } from '../modules/amplify/auth';

export enum Stages {
  context = 'context',
  declaration = 'declaration',
  evaluation = 'evaluation',
  negotiation = 'negotiation',
  realization = 'realization',
}

export interface Stage {
  id: string;
  key: number;
  name: string;
  edgeName: string;
}

export const getStages = async (): Promise<Stage[]> => {
  const response = await fetch(`${REACT_APP_API_BASE_URL}/stages`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${cookies.get(ACCESS_TOKEN_COOKIE_KEY) ?? ''}`,
    },
  });
  return await response.json();
};
